import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/globals.css";
import ReactGA from "react-ga4";

import packageJson from "../package.json";

import App from "./App";
console.log(`v${packageJson.version}`);

// Initialize GA4
ReactGA.initialize("G-0CCRN7NQLT");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
